export type Role =
  | "admin"
  | "seller"
  | "landlord"
  | "buyer"
  | "tenant"
  | "agent"
  | "lawyer"
  | "valuer";

export type RoleUser = {
  role?: string | null;
  role_type?: string | null;
  role_name?: string | null;
  role_id?: string | number | null;
} | null | undefined;

const roleAliases: Record<string, Role> = {
  admin: "admin",
  super_admin: "admin",
  seller: "seller",
  property_seller: "seller",
  landlord: "landlord",
  property_owner: "landlord",
  buyer: "buyer",
  tenant: "tenant",
  agent: "agent",
  real_estate_agent: "agent",
  lawyer: "lawyer",
  legal_practitioner: "lawyer",
  valuer: "valuer",
  property_valuer: "valuer",
  company_realtor: "agent",
  realtor: "agent",
};

// Existing CASA role IDs.
const rolesById: Record<string, Role> = {
  "3": "tenant",
  "4": "agent",
  "5": "landlord",
  "6": "lawyer",
  "7": "agent", // Company realtor
  "8": "buyer",
  "9": "valuer",
};

export function resolveRole(user: RoleUser): Role {
  const rawRole = [user?.role, user?.role_type, user?.role_name].find(
    (value) => typeof value === "string" && value.trim()
  );

  const normalizedRole = String(rawRole ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (roleAliases[normalizedRole]) {
    return roleAliases[normalizedRole];
  }

  return rolesById[String(user?.role_id ?? "")] ?? "buyer";
}
